const globalLazyGetterCache = new WeakMap(); // 有的对象 isFrozen 的，这时也要支持能用
const sym = Symbol(`lazyGetterCache`);
const getCache = (o) => {
    if (!Object.isExtensible(o)) {
        let ans = globalLazyGetterCache.get(o);
        if (!ans)
            globalLazyGetterCache.set(o, (ans = {}));
        return ans;
    }
    // 本来应该都用 weakMap 就行，但是要避免有的人使用了 WeakMap 的 polyfill 把 GC 搞挂
    let ans = o[sym];
    if (!ans) {
        Object.defineProperty(o, sym, {
            enumerable: false,
            configurable: true,
            value: (ans = {}),
        });
    }
    return ans;
};
function wrapGetter(key, getter) {
    return function () {
        const cache = getCache(this);
        const called = key in cache;
        const value = called ? cache[key] : getter.call(this);
        if (!called)
            Object.defineProperty(cache, key, { value });
        return value;
    };
}
export default function defineLazyGetter(obj, key, getter) {
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        get: wrapGetter(key, getter),
    });
}
/**
 * 用于 TypeScript class 的 getter 的修饰器。
 *
 * 例：
 *
 * ```js
 * class Foo {
 *   @LazyGetter()
 *   get bar(){ return 24; }
 * }
 * ```
 */
export const LazyGetter = () => (target, key, desc) => {
    desc.get = wrapGetter(key, desc.get);
};
